/* 🤖 this file was generated by script */
export const wiconArrowNarrowLeft = {
  name: 'arrow_narrow_left',
  data: `<svg viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 12H4m0 0l6 6m-6-6l6-6"/></svg>`,
};
